import {useCallback, useEffect, useRef, useState} from 'react';
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  List,
  Modal,
  Select,
  Spin,
  Typography,
} from 'antd';
import {useParams} from 'react-router-dom';
import type {
  NewEnrollment,
  NewCreateEnrollmentInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/enrollment/graphql/enrollment.interface';
import {SchoolService} from './SchoolService';
import {ClassesConnection, Classschool} from '../../graphql/API';
import {PackagesService} from '../Package';
import ProfilePictureCard from '../../components/ProfilePictureCard';
import {UserService} from '../User';
import {StudentsService} from '../Students';
import {EnrollmentsService} from '../Enrollments/EnrollmentsService';
import {EditClassCurriculumLevelsModal} from './EditClassCurriculumLevels';
import {getCurrentUser} from 'aws-amplify/auth';
import {NewPackage} from '@PikaDoApp/npm-pikado-logic/dist/modules/package/graphql/package.interface';
const schoolsService = new SchoolService();
const packagesService = new PackagesService();
const usersService = new UserService();
const studentsService = new StudentsService();
const enrollmentsService = new EnrollmentsService();
interface DataType {
  id: string;
  name: string;
}

interface DataTypeApply {
  id: string;
  packageId: string;
  discountcodeId: string;
}

export const SchoolEdit = () => {
  let params: {schoolId: string} = useParams();

  const {Title, Text} = Typography;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<DataType[]>([]);
  const [dataApply, setDataApply] = useState<DataTypeApply[]>([]);

  const [packages, setPackages] = useState<Array<NewPackage> | []>([]);
  const [school, setSchool] = useState<any>();
  const [isStudentModalOpen, setIsStudentModalOpen] = useState<boolean>(false);
  const [studentForm] = Form.useForm();
  const [selectedClass, setSelectedClass] = useState<any>();
  const [isSavingStudent, setIsSavingStudent] = useState<boolean>(false);
  const [isEditCurrModalOpen, setIsEditCurrModalOpen] =
    useState<boolean>(false);
  const [selectedClassId, setSelectedClassId] = useState<string>('');

  const handleStudentModalOk = useCallback(async () => {
    if (!selectedClass) {
      alert('Please select a class before saving.');
      return;
    }

    setIsSavingStudent(true);
    try {
      // TODO:
      //1- create cognito user
      //2- create system user
      //3- create student object
      //4- fetch first student in school to get discountcode id in his enrollment and startdate to give the new user the same value to be able to get the same exersices
      //5- create new enrollment object

      const values = await studentForm.validateFields();
      debugger;
      // Create the complete student object with all required data
      const studentData = {
        ...values,
        classSchoolId: selectedClass.id,
        schoolId: params.schoolId,
        birthdate: values.birthdate?.format('YYYY-MM-DD'),
      };

      console.log('Complete student data:', studentData);
      const cognitoUser = await usersService.adminCreateCognitoUser(
        studentData.phone.trim(),
        studentData.email.trim(),
        studentData.password.trim(),
      );
      const newUser = await usersService.createUser(
        cognitoUser.username,
        'Asia/riyadh',
        studentData.phone.trim(),
      );
      const newStudent = await studentsService.createStudent(
        newUser.id,
        studentData.name,
        studentData.birthdate,
        studentData.age,
        studentData.gender,
        studentData.schoolId,
        true,
        selectedClass.id,
      );
      const studentsInClass = await studentsService.getStudentsByClassId(
        selectedClass.id,
      );

      if (!studentsInClass?.length) return;
      let validStudentClassEnrollment: NewEnrollment = null;

      for (const student of studentsInClass) {
        const validEnrollment: NewEnrollment | undefined = (
          await enrollmentsService.getEnrollmentsByStudentId(
            student._id ?? student.id,
          )
        ).find((enrollment: NewEnrollment) => {
          console.log('enrollment', enrollment);
          return (
            !!enrollment.packageId?._id &&
            !!enrollment.curriculumId &&
            !!enrollment.startDate &&
            !!enrollment.enrollmentStatus &&
            enrollment.enrollmentStatus == 'ACTIVE' &&
            enrollment.isDeleted == false
          );
        });
        if (validEnrollment) {
          validStudentClassEnrollment = validEnrollment;
          break;
        }
      }

      // Get current user for createdBy field
      let createdBy = 'unknown';
      try {
        const user = await getCurrentUser();
        createdBy = user.signInDetails?.loginId || user.userId || 'unknown';
      } catch (error) {
        console.error('Error getting current user:', error);
      }

      const enrollmentInsert: NewCreateEnrollmentInput = {
        studentId: newStudent.id,
        packageId: validStudentClassEnrollment.packageId._id || '',
        placementStatus: 'TODO' as any,
        createdBy: createdBy,
        levelId: validStudentClassEnrollment.levelId || null,
        placementTestId: validStudentClassEnrollment.placementTestId || null,
        discountCodeId: validStudentClassEnrollment.discountCodeId?._id || null,
        curriculumId: validStudentClassEnrollment.curriculumId || 'PIKADO',
        startDate: validStudentClassEnrollment.startDate,
        finalPrice: {
          currency: 'USD',
          price: 0,
        },
        paymentMethod: 'paymob',
      };
      const createNewStudentEnrollment =
        await enrollmentsService.createEnrollment(enrollmentInsert);
      // setIsStudentModalOpen(false);
      studentForm.resetFields();
      setSelectedClass(null);
      setIsStudentModalOpen(false);
      alert('Student has been successfully created.');
    } catch (error: any) {
      console.error('Failed to create student:', error);
      if (error?.errorFields) {
        return; // Validation errors are displayed by the form
      }

      const graphQLErrorMessage =
        Array.isArray(error?.errors) &&
        typeof error.errors[0]?.message === 'string'
          ? error.errors[0].message
          : undefined;
      const errorMessage =
        graphQLErrorMessage ??
        (typeof error?.message === 'string'
          ? error.message
          : 'An unexpected error occurred while creating the student.');

      alert(`Error creating student: ${errorMessage}`);
    } finally {
      setIsSavingStudent(false);
    }
  }, [studentForm, selectedClass, params.schoolId]);

  const handleStudentModalCancel = useCallback(() => {
    setIsStudentModalOpen(false);
    studentForm.resetFields();
  }, [studentForm]);

  useEffect(() => {
    //console.log('rams.sch', params.schoolId);
    schoolsService
      .getSchoolById(params.schoolId)
      .then(e => {
        setSchool(e);
      })
      .catch(e => {
        alert(`Error in getSchoolById: ${e}`);
      });
    schoolsService
      .getClassesBySchoolId(params.schoolId)
      .then(async (classess: ClassesConnection) => {
        const newData = classess?.items?.map((classS: Classschool) => {
          const tempDataApply = [...dataApply];
          tempDataApply.push({
            id: classS.id,
            packageId: '',
            discountcodeId: '',
          });

          setDataApply(tempDataApply);

          return {
            name: classS.name,
            id: classS.id,
          };
        });
        setData(newData);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
        alert(`Error in fetching classesBySchoolId`);
        console.log('getClassesBySchoolId Error:', error);
      });

    packagesService
      .getPackages(1, 100)
      .then(pkgs => {
        //console.log('pkgs', pkgs);
        const exercisesPackages = pkgs.items.filter((pack: any) => pack.onlyAI);
        setPackages(exercisesPackages as any);
      })
      .catch(error => {
        setIsLoading(true);
        alert('Error in getPackages');
        console.log('Error getPackages->', error);
      });
  }, []);

  return (
    <div style={{padding: 10}}>
      {school?.logoUrl ? (
        <div>
          <p>School logo:</p>
          <ProfilePictureCard thumbnailUri={school.logoUrl} />
        </div>
      ) : (
        <p>No school logo provided</p>
      )}
      <Title style={{textAlign: 'center'}}>Activate Classess</Title>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
        }}>
        <thead>
          <tr>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '12px',
                textAlign: 'left',
                width: '20%',
              }}>
              Class Name
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '12px',
                textAlign: 'left',
                width: '25%',
              }}>
              Select Package
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '12px',
                textAlign: 'left',
                width: '25%',
              }}>
              Enter discount code (ID)
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '12px',
                textAlign: 'left',
                width: '30%',
              }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index: number) => (
            <tr key={item.id}>
              <td
                style={{
                  border: '1px solid #ddd',
                  padding: '12px',
                  fontWeight: 'bold',
                  fontSize: 16,
                  verticalAlign: 'middle',
                }}>
                {item.name}
              </td>
              <td
                style={{
                  border: '1px solid #ddd',
                  padding: '12px',
                  verticalAlign: 'middle',
                }}>
                <Select
                  value={dataApply[index]?.packageId}
                  showSearch
                  style={{width: '100%'}}
                  placeholder="Select a package"
                  optionFilterProp="children"
                  onChange={pkgId => {
                    if (
                      dataApply[index]?.packageId ||
                      dataApply[index]?.discountcodeId
                    ) {
                      let tempDataApply = [...dataApply];

                      tempDataApply[index] = {
                        ...dataApply[index],
                        packageId: pkgId,
                      };

                      setDataApply(tempDataApply);
                    } else {
                      const newDataApply: DataTypeApply = {
                        id: item.id,
                        discountcodeId: dataApply[index]?.discountcodeId,
                        packageId: pkgId,
                      };

                      let tempDataApply = [...dataApply];
                      tempDataApply[index] = newDataApply;

                      setDataApply(tempDataApply);
                    }
                  }}>
                  {packages?.map((pkg: NewPackage) => (
                    <Select.Option key={pkg._id} value={pkg._id}>
                      {pkg.name_i18n.en}
                    </Select.Option>
                  ))}
                </Select>
              </td>
              <td
                style={{
                  border: '1px solid #ddd',
                  padding: '12px',
                  verticalAlign: 'middle',
                }}>
                <Input
                  style={{width: '100%'}}
                  placeholder="Enter a valid (ID)"
                  value={dataApply[index]?.discountcodeId}
                  onChange={event => {
                    if (
                      dataApply[index]?.discountcodeId ||
                      dataApply[index]?.packageId
                    ) {
                      let tempDataApply = [...dataApply];

                      tempDataApply[index] = {
                        ...dataApply[index],
                        discountcodeId: event.target.value,
                      };

                      setDataApply(tempDataApply);
                    } else {
                      const newDataApply: DataTypeApply = {
                        id: item.id,
                        discountcodeId: event.target.value,
                        packageId: dataApply[index]?.packageId,
                      };
                      let tempDataApply = [...dataApply];
                      tempDataApply[index] = newDataApply;
                      setDataApply(tempDataApply);
                    }
                  }}
                />
              </td>
              <td
                style={{
                  border: '1px solid #ddd',
                  padding: '12px',
                  verticalAlign: 'middle',
                }}>
                <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
                  <Button
                    type="default"
                    size="small"
                    onClick={() => {
                      setSelectedClassId(item.id);
                      setIsEditCurrModalOpen(true);
                    }}>
                    Edit Curr and Levels
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                      setIsStudentModalOpen(true);
                      console.log(item, 'data');
                      setSelectedClass(item);
                    }}>
                    Add Student
                  </Button>
                  <Button
                    type="link"
                    size="small"
                    onClick={async () => {
                      if (
                        dataApply[index]?.id &&
                        dataApply[index]?.discountcodeId?.length !== 0 &&
                        dataApply[index]?.packageId
                      ) {
                        try {
                          setIsLoading(true);
                          await schoolsService.activateSubsctiptionInClass(
                            dataApply[index].id,
                            dataApply[index].discountcodeId,
                            dataApply[index].packageId,
                          );
                          setIsLoading(false);
                        } catch (error) {
                          alert(JSON.stringify(error));
                          setIsLoading(false);
                        }
                      } else {
                        alert('Please check the entered data');
                      }
                    }}>
                    Create
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )} */}
      <Modal
        title={`Add Student ${' '}${selectedClass?.name}`}
        open={isStudentModalOpen}
        onOk={handleStudentModalOk}
        onCancel={handleStudentModalCancel}
        okText="Save"
        okButtonProps={{loading: isSavingStudent}}>
        <Form
          form={studentForm}
          layout="vertical"
          initialValues={{gender: 'FEMALE'}}>
          <Form.Item
            label="Student Name"
            name="name"
            rules={[{required: true, message: 'Please enter student name'}]}>
            <Input placeholder="Enter student name" />
          </Form.Item>
          <Form.Item
            label="Age"
            name="age"
            rules={[{required: true, message: 'Please enter age'}]}>
            <InputNumber
              style={{width: '100%'}}
              min={1}
              placeholder="Enter age"
            />
          </Form.Item>
          <Form.Item
            label="Birthdate"
            name="birthdate"
            rules={[{required: true, message: 'Please select birthdate'}]}>
            <DatePicker style={{width: '100%'}} />
          </Form.Item>
          <Form.Item
            label="Gender"
            name="gender"
            rules={[{required: true, message: 'Please select gender'}]}>
            <Select>
              <Select.Option value="FEMALE">Female</Select.Option>
              <Select.Option value="MALE">Male</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phone"
            rules={[{required: true, message: 'Please enter phone number'}]}>
            <Input placeholder="Enter phone number" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{required: true, message: 'Please enter email'}]}>
            <Input type="email" placeholder="Enter email" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{required: true, message: 'Please enter password'}]}>
            <Input.Password placeholder="Enter password" />
          </Form.Item>
        </Form>
      </Modal>
      {isEditCurrModalOpen && (
        <EditClassCurriculumLevelsModal
          classId={selectedClassId}
          isOpen={isEditCurrModalOpen}
          onClose={() => setIsEditCurrModalOpen(false)}
        />
      )}
    </div>
  );
};
